import { ServiceProvider } from "../../dependencies_management/ServiceProvider";
import { GaEventData } from "../../types/GaEventData";
import { AnalyticsTracker } from "../AnalyticsTracker";
import { CompositeGoogleAnalyticsTracker } from "./CompositeGoogleAnalyticsTracker";
import { GlobalSiteTagAnalyticsTracker } from "./GlobalSiteTagAnalyticsTracker";
import { GoogleAnalyticsTracker } from "./GoogleAnalyticsTracker";
import { GoogleAnalyticsTrackerFactory } from "./GoogleAnalyticsTrackerFactory";
import { GoogleAnalyticsTrackerOptions } from "./GoogleAnalyticsTrackerOptions";

export class DefaultGoogleAnalyticsTrackerFactory
	implements GoogleAnalyticsTrackerFactory
{
	constructor(private readonly serviceProvider: ServiceProvider) {
		// intentionally left empty
	}

	createTracker(
		options: GoogleAnalyticsTrackerOptions
	): AnalyticsTracker<GaEventData> {
		const trackers = [
			new GoogleAnalyticsTracker(options, this.serviceProvider),
			new GlobalSiteTagAnalyticsTracker(options, this.serviceProvider),
		];
		return new CompositeGoogleAnalyticsTracker(trackers);
	}
}
